function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { ButtonPrimary } from "../../";
export const ButtonBandsintown = ({
  children,
  ...props
}) => {
  return React.createElement(ButtonBandsintownWrap, _extends({}, props, {
    iconLeft: React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 30 32"
    }, React.createElement("g", {
      id: "Logos",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, React.createElement("g", {
      id: "Logo/Third-Party/BandsInTown/Reversed",
      transform: "translate(-1.000000, 0.000000)",
      fill: "#FFFFFF"
    }, React.createElement("path", {
      d: "M31,26 L31,32 L7,32 L1,32 L1,0 L7,0 L7,26 L25,26 L25,24 L9,24 L9,18 L31,18 L31,24 L31,26 Z M25,0 L31,0 L31,16 L25,16 L25,0 Z M17,8 L23,8 L23,16 L17,16 L17,8 Z M9,8 L15,8 L15,16 L9,16 L9,8 Z",
      id: "Combined-Shape"
    }))))
  }), children);
};
export const ButtonBandsintownWrap = styled(ButtonPrimary)`
  background-color: ${props => props.theme.colors.bandsintown};
  color: #ffffff;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.bandsintown};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
`;